var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 24.6667,
    cy: 24.3193,
    r: 23.5,
    fill: "white",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6783 18.1667L29.6667 14.6667C29.6667 14.025 29.1417 13.5 28.5 13.5C27.8583 13.5 27.3333 14.025 27.3333 14.6667V18.1667H22.6667V14.6667C22.6667 14.025 22.1417 13.5 21.5 13.5C20.8583 13.5 20.3333 14.025 20.3333 14.6667V18.1667H20.3217C19.05 18.1667 18 19.2167 18 20.4883V25.925C18 26.5433 18.245 27.1383 18.6767 27.57L22.0833 31V33.3333C22.0833 33.975 22.6083 34.5 23.25 34.5H26.75C27.3917 34.5 27.9167 33.975 27.9167 33.3333V31L31.3233 27.5933C31.755 27.15 32 26.555 32 25.9367V20.4883C32 19.205 30.9617 18.1667 29.6783 18.1667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.456458b9fe71bdf4226def24e9f25e94.svg";
export { ForwardRef as ReactComponent };